import { Injectable } from '@angular/core';
import { FormControl } from '@ngneat/reactive-forms';
import { BehaviorSubject, Observable } from 'rxjs';
import { IDescontoRodape } from '../../models/desconto.models';
import { SelectClientService } from '@brunsker/libs/portal-do-vendedor/utils/portal-vendedor-api/lib/services/select-client/select-client.service';
import { NewApiProductService } from '@brunsker/libs/portal-do-vendedor/utils/portal-do-vendedor-new-api/lib/services/api/new-api-product/new-api-product.service';

@Injectable({
  providedIn: 'root',
})
export class DescontoService {
  rodaPeIsConfirmed$$ = new BehaviorSubject(true);
  rodaPeRollBack$$ = new BehaviorSubject(true);
  changeDescontoItem$$ = new BehaviorSubject(true);
  changeDescontoRodape$$ = new BehaviorSubject<IDescontoRodape>({
    value: 0,
    prefix: '%',
  });
  descontoRodapeValue$ = new FormControl<IDescontoRodape>({
    value: 0,
    prefix: '%',
  });
  descontoTotalVlTotal$ = new FormControl<{ vlTotal: number }>({ vlTotal: 0 });
  PrefixRodapeCont$ = new FormControl<number>(0);

  constructor(
    private readonly selectClientService: SelectClientService,
    private newApiProductService: NewApiProductService,
  ) {}

  getMaxDiscount(productId: number, idFuncionario: number) {
    const currentClient = this.selectClientService.getCliente();
    return this.newApiProductService.getProductDiscount({
      CodigoFilial: currentClient?.filial ?? 1,
      CodigoCliente: currentClient?.id ?? 0,
      CodigoVendedor: currentClient?.vendedor ?? undefined,
      CodigoParcela: currentClient?.planoDePagamento ?? undefined,
      CodigoProduto: productId ?? undefined,
      matricula: idFuncionario,
    });
  }
}
